const formatTime = date => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();

    let time1 = `${[year, month, day].map(formatNumber).join('-')}`
    let time2 = `${[hour, minute, second].map(formatNumber).join(':')}`
    let time3 = `${[year, month, day].map(formatNumber).join('-')} ${[hour, minute, second].map(formatNumber).join(':')}`
    let time4 = `${[year, month].map(formatNumber).join('-')}`
    return {
        time1: time1,
        time2: time2,
        time3: time3,
        time4: time4
    }
};

const formatNumber = n => {
    n = n.toString();
    return n[1] ? n : `0${n}`
};

module.exports = {
    formatTime,
};